import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-whatsappicon',
  templateUrl: './whatsappicon.component.html',
  styleUrls: ['./whatsappicon.component.css']
})
export class WhatsappiconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
